import './init-sentry';

// eslint-disable-next-line import/order
import * as Sentry from '@sentry/react';

Sentry.setTag('app', 'crm-app');

import React from 'react';
import { App as AntdApp } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './i18n.ts';
import './index.css';
import { initDevMode } from './services/dev-mode/dev-mode';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AntdApp>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools />
      </QueryClientProvider>
      {initDevMode()}
    </AntdApp>
  </React.StrictMode>,
);
